module.exports = __webpack_public_path__ + "static/media/weld_insp_1.53bd606c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/manual/weld_insp_1.jpg
// module id = 1870
// module chunks = 0